module.exports = __webpack_public_path__ + "static/media/english.38f88714.svg";